import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "../../own/locale/en.json";
import ar from "../../own/locale/ar.json";
import sidebarMenuEn from "../../own/locale/sidebarMenu.en.json";
import sidebarMenuAr from "../../own/locale/sidebarMenu.ar.json";

Vue.use(VueI18n);

const messages = {
  en: { ...en, ...sidebarMenuEn },
  ar: { ...ar, ...sidebarMenuAr },
};

const lang = localStorage.getItem("language") || "en";

function humanizeKey(key) {
  return key
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: "en",
  messages,
  silentFallbackWarn: true,
  postTranslation: (value, key) => {
    if (value === null || value === undefined || value === key) {
      return humanizeKey(key);
    }
    return value;
  },
});

export default i18n;
